import { gql } from '@apollo/client';
export const PARAMETER_TEMPLATE_FIELDS = gql`
  fragment ParameterTemplateFields on ParameterTemplateDto {
    id
    defaultValues {
      code
      id
      text
    }
  }
`;